module.exports = __webpack_public_path__ + "img/lead-discount.7a75c201.svg";